import { action, computed, observable } from 'mobx';

export default class Collection {
  @observable models = observable.map();

  @action
  add(model) {
    // eslint-disable-next-line no-console
    if (!model.id) return console.error(`Model missing id: ${model}`);
    this.models.set(model.id, model);
  }

  forEach(func) {
    return this.models.forEach(func);
  }

  some(func) {
    return this.models.values().some(func);
  }

  filter(func) {
    const results = [];
    this.models.forEach(model => model && func(model) && results.push(model));
    return results;
  }

  find(func) {
    let result = null;
    this.models.values().some(model => {
      if (model && func(model)) {
        result = model;
        return true;
      }
      return false;
    });
    return result;
  }

  get(modelId) {
    return this.models.get(modelId);
  }

  has(modelId) {
    return this.models.has(modelId);
  }

  map(func) {
    return this.models.values().map(func);
  }

  @action
  remove(model) {
    this.models.delete(model.id);
  }

  sort(func) {
    const results = this.models.values();

    return results.sort(func);
  }

  @action
  clear() {
    this.models.clear();
  }

  @computed
  get size() {
    return this.models.size;
  }

  values() {
    return this.models.values().map(value => value);
  }
}
